import React, { useCallback, useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import Btn, { FormBtn } from 'components/Btn'
import StepOne from './StepOne'
import StepTwo from './StepTwo'
import StepThree from './StepThree'
import { useFormContext } from 'react-hook-form'
import { apiRequest } from 'store/Misc/apiRequest'
import { toast } from 'react-toastify'

export default withTranslation()(function RegistrationForm({ t, validationFields, steps: { step, setstep }, yupFields: { isDirty, isValid } }) {

  const { watch } = useFormContext()
  const [phoneErrorState, setPhoneErrorState] = useState(true) //check phone validation for each country
  const phoneError = watch('phoneError')
  useEffect(() => {
    if (step === 0) { setPhoneErrorState(phoneError) } else { setPhoneErrorState(true) }
  }, [phoneError, watch, step])

  const checkEmail = useCallback(async () => {
    try {
      await apiRequest({
        url: 'merchants/validate/email',
        method: 'post',
        payload: { email: watch('primary_email') }
      })
    } catch (error) {
      if (Error(error).message.includes('email')) {
        setstep(0)
        toast.error('This email is taken')
      }
    }
  }, [watch, setstep])

  useEffect(() => {
    checkEmail()
  }, [checkEmail])

  return (
    <div className="max-h-[80vh] mt-5 overflow-hidden !w-[100%] scrollbar-thin">
      <div className="mb-2 font-medium text-secondary text-center">
        {t('misc.steps', { step: (step + 1), totalSteps: validationFields.length })}
      </div>
      {
        formSwitcher(step)
      }
      <div className="flex gap-3 mt-7 pb-8 mx-auto justify-center items-center">
        {
          step > 0 && (
            <Btn
              content={t('misc.back')}
              className="w-36 h-12 text-white rounded-xl !bg-primary hover:bg-primary"
              disabled={step === 0}
              click={() => setstep(step - 1)}
            />
          )
        }
        {
          step > 1 ? (
            <FormBtn
              content={'Sign up'}
              className="w-36 h-12 text-white rounded-xl bg-success hover:bg-success"
              disabled={!isValid || !isDirty}
            />
          ) : (
            <div className="w-36 h-12 overflow-hidden">
              <Btn
                content={t('misc.next')}
                className="w-36 h-12 text-white rounded-xl bg-primary hover:bg-primary"
                disabled={(!isValid || !isDirty) || !phoneErrorState}
                click={() => setstep(step + 1)}
              />
            </div>
          )
        }
      </div>
    </div>
  )
})
const formSwitcher = (step) => {

  switch (step) {
    case 0:
      return <StepOne />

    case 1:
      return <StepTwo />

    case 2:
      return <StepThree />

    default:
      return
  }
}